// src/config/brandConfig.js
export const BRAND = {
  name: "Harborline Wealth",
  tagline: "Modern wealth stewardship for New England families & businesses",

  colors: {
    // Core semantic tokens
    ink: "#0B1A3C",
    ink70: "#0B1A3CB3",
    muted: "#6B7280",
    line: "#E5E7EB",
    bg: "#F7F8FA",
    card: "#FFFFFF",

    // Brand
    brand: "#0B3C5D", // Harbor blue
    brand10: "rgba(11,60,93,0.10)",
    brand20: "rgba(11,60,93,0.20)",

    // States
    success: "#16A34A",
    warning: "#F59E0B",
    danger: "#DC2626",
    info: "#1D4ED8",

    // Legacy aliases (for incremental refactors)
    accent: "#0B3C5D",
    accentDark: "#093348",
    accentLight: "#1e6091",
    textDark: "#0f172a",
    textMedium: "#475569",
    textLight: "#94a3b8",
    border: "rgba(148,163,184,0.25)",
    borderStrong: "rgba(148,163,184,0.40)",
    panel: "#ffffff",
    panelSoft: "rgba(11,60,93,0.05)",
    background: "#f5f7fa",
  },

  radii: { sm: "8px", md: "12px", lg: "16px", xl: "20px", full: "999px" },

  shadows: {
    xs: "0 1px 2px rgba(0,0,0,.06)",
    sm: "0 2px 4px rgba(0,0,0,.08)",
    md: "0 4px 14px rgba(0,0,0,.08)",
  },

  spacing: [4, 8, 12, 16, 24, 32],

  type: {
    HeadingXL: { size: 28, lineHeight: 34 },
    HeadingLG: { size: 22, lineHeight: 28 },
    Body: { size: 14, lineHeight: 20 },
    Label: { size: 12, lineHeight: 16 },
  },

  focus: {
    ring: "0 0 0 3px rgba(11,60,93,.40)", // visible focus ring (brand/40)
  },

  motion: {
    ease: "cubic-bezier(.2,.8,.2,1)",
    fast: "150ms",
    base: "250ms",
    hoverLift: "translateY(-1px)",
    activePress: "translateY(1px)",
  },

  // Semantic usage map to nudge teams towards consistency
  semantic: {
    text: {
      primary: "ink",
      secondary: "ink70",
      muted: "muted",
      inverse: "card",
    },
    surface: { page: "bg", card: "card", subtle: "brand10" },
    border: { default: "line" },
    cta: { bg: "brand", bgHover: "#09405F", text: "card" }, // darker hover maintains 3:1 on button
    states: {
      success: { bg: "success", on: "card" },
      warning: { bg: "warning", on: "ink" },
      danger: { bg: "danger", on: "card" },
      info: { bg: "info", on: "card" },
    },
  },

  layout: {
    container: { maxWidth: "80rem", paddingX: "1.5rem", paddingXMd: "2rem" },
    header: { sticky: true, divider: true },
  },
};
